import PollingContainer from 'global/StreamWidget/PollingContainer';
import TargetPriceContainer from 'global/StreamWidget/TargetPriceContainer';
import DocumentContainer from 'global/StreamWidget/Post/DocumentContainer';
import YoutubePlayer from 'global/StreamWidget/Post/YoutubePlayer';
import RepostBox from 'global/StreamWidget/Post/RepostBox';
import ImageSlider from 'global/ImageSlider';
import TitleContent from 'global/StreamWidget/Post/TitleContent';
import Header from './Header';
import TextContent from '../../StreamWidget/TextContent';
import Footer from './Footer';
import NestedReplyBox from './NestedReplyBox';
import { StreamPostData } from '../../../../@types/stream';
import { ItemConversationContainer } from '../styled';
import CommentLimitInfo from './CommentLimitInfo';

interface ItemConversationProps {
  post: StreamPostData;
  showCommentLimitInfo?: boolean;
  isAuthorDetailPost: boolean;
  type: 'comment' | 'post';
  onComment: (val: any) => any;
  handleClose: () => void;
}

function ItemConversation({
  post,
  showCommentLimitInfo = false,
  isAuthorDetailPost,
  type,
  onComment,
  handleClose,
}: ItemConversationProps) {
  const {
    content,
    polling,
    content_original: contentOriginal,
    mask_html: maskHtml,
    replyto,
    reply_content: replyContent,
    images,
    images_data: imageData,
    attachment,
    target_price: targetPrice,
    reposted,
    repostedfrom,
    image_frame_type: frameType,
    title,
    titleurl,
    is_author: isAuthor,
  } = post;

  const handleComment = () => {
    onComment(post);
  };

  const isHaveImage = images.length > 0 && images[0] !== '';

  return (
    <>
      <Header
        post={post}
        type={type}
        isAuthorDetailPost={isAuthorDetailPost}
        handleClose={handleClose}
      />
      <ItemConversationContainer>
        {polling.length > 0 ? (
          <PollingContainer post={post} isSinglePost />
        ) : (
          <>
            {title && titleurl && (
              <TitleContent title={title} titleUrl={titleurl} />
            )}

            <TextContent content={content} maskedHtml={maskHtml} />
            {isHaveImage
              ? (
                <ImageSlider
                  images={imageData}
                  frameType={frameType}
                  mode="comment"
                />
              )
              : <YoutubePlayer content={contentOriginal} />}
            {attachment.length > 0 && (
              <DocumentContainer documents={attachment} />
            )}

            {targetPrice.length > 0 && (
              <TargetPriceContainer
                targetPrice={targetPrice[0]}
                postid={post.postid}
                isAuthor={isAuthor}
              />
            )}

            {parseInt(replyto, 10) > 0 && replyContent && (
              <NestedReplyBox
                content={replyContent.content}
                username={replyContent.username}
              />
            )}
          </>
        )}
        {reposted > 0 && <RepostBox post={repostedfrom} />}
        <Footer post={post} onComment={handleComment} />
        {showCommentLimitInfo && <CommentLimitInfo type={post.commenter_type} />}
      </ItemConversationContainer>
    </>
  );
}

export default ItemConversation;
